import A from 'const/actionTypes'
import initialState from 'store/initialState'

export default (currentState, action) => {
  let updatedState = currentState || initialState

  switch (action.type) {
    case A.SET_COUNTER_STRIKE_GLOBAL_OFFENSIVE_PACK:
      const salePrice = action.counterStrikeGlobalOffensivePack.salePrice
      const basePrice = action.counterStrikeGlobalOffensivePack.price
      updatedState.counterStrikeGlobalOffensivePackPurchaseAmount = salePrice || basePrice
      updatedState.counterStrikeGlobalOffensivePackId = action.counterStrikeGlobalOffensivePack.id
      break
    case A.SET_DONATION_AMOUNT:
      updatedState.donationAmount = action.donationAmount
      break
    case A.SET_SOUND_PACK:
      updatedState.soundPackPurchaseAmount = action.soundPack.price
      updatedState.soundPackId = action.soundPack.id
      break
  }

  return updatedState
}



// WEBPACK FOOTER //
// ./src/app/reducers/purchases.js